import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";

const NotFoundScreen = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-black p-4">
            <Card className="w-full max-w-md bg-zinc-950 border-zinc-800 text-white shadow-2xl text-center">
                <CardHeader>
                    <CardTitle className="text-3xl font-bold tracking-tight text-red-600">404</CardTitle>
                    <CardDescription className="text-zinc-400 text-sm">Page Not Found</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <p className="text-sm text-zinc-300">The page you are looking for does not exist.</p>
                    <Button asChild variant="secondary">
                        <Link to="/transaction">Go to Home</Link>
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
};

export default NotFoundScreen;
